import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getAppConfig } from '../../../config';
import { loadCredentials } from '../../../apiClient';
import { GET_CONVERSATIONS_QUERY_KEY } from './useGetConversations';

export function useDeleteConversation(organizationId: string | undefined) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (conversationId: string) => {
      const { idToken } = loadCredentials();
      const response = await fetch(
        `${getAppConfig().apiUrl}/ai-assistant/conversations/${conversationId}`,
        {
          method: 'DELETE',
          headers: {
            authorization: idToken,
            'x-organization-id': organizationId!,
          },
        },
      );

      if (!response.ok) {
        const body = await response.json().catch(() => null);
        throw new Error(body?.message || `Request failed (${response.status})`);
      }

      return response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: GET_CONVERSATIONS_QUERY_KEY(organizationId ?? ''),
      });
    },
  });
}
